"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppSettings_1 = require("./api/v1/AppSettings");
var AtlasCluster_1 = require("./api/v1/AtlasCluster");
var AtlasDataLake_1 = require("./api/v1/AtlasDataLake");
var AtlasGroup_1 = require("./api/v1/AtlasGroup");
var ClusterStorageMetrics_1 = require("./api/v1/ClusterStorageMetrics");
var Region_1 = require("./api/v1/Region");
var TempAPIKey_1 = require("./api/v1/TempAPIKey");
var APIKey_1 = require("./api/v3/APIKey");
var App_1 = require("./api/v3/App");
var AtlasAPIKey_1 = require("./api/v3/AtlasAPIKey");
var AuthProvider_1 = require("./api/v3/AuthProvider");
var CodeDeploy_1 = require("./api/v3/CodeDeploy");
var DataAPI_1 = require("./api/v3/DataAPI");
var DebugExecuteFunction_1 = require("./api/v3/DebugExecuteFunction");
var Dependencies_1 = require("./api/v3/Dependencies");
var Deployment_1 = require("./api/v3/Deployment");
var DeploymentMigration_1 = require("./api/v3/DeploymentMigration");
var Draft_1 = require("./api/v3/Draft");
var Endpoint_1 = require("./api/v3/Endpoint");
var EnvironmentValue_1 = require("./api/v3/EnvironmentValue");
var EventSubscription_1 = require("./api/v3/EventSubscription");
var Function_1 = require("./api/v3/Function");
var GraphQL_1 = require("./api/v3/GraphQL");
var Hosting_1 = require("./api/v3/Hosting");
var IncomingWebhook_1 = require("./api/v3/IncomingWebhook");
var IPAccess_1 = require("./api/v3/IPAccess");
var Log_1 = require("./api/v3/Log");
var LogForwarder_1 = require("./api/v3/LogForwarder");
var Measurement_1 = require("./api/v3/Measurement");
var Metric_1 = require("./api/v3/Metric");
var ProviderRegionData_1 = require("./api/v3/ProviderRegionData");
var Push_1 = require("./api/v3/Push");
var Rule_1 = require("./api/v3/Rule");
var Schema_1 = require("./api/v3/Schema");
var Secret_1 = require("./api/v3/Secret");
var Service_1 = require("./api/v3/Service");
var Sync_1 = require("./api/v3/Sync");
var Template_1 = require("./api/v3/Template");
var User_1 = require("./api/v3/User");
var UserSettings_1 = require("./api/v3/UserSettings");
var ValidationOptions_1 = require("./api/v3/ValidationOptions");
var Value_1 = require("./api/v3/Value");
var auth_1 = __importDefault(require("./auth"));
var Common_1 = require("./Common");
var Error_1 = require("./Error");
var bson_1 = require("bson");
var json2typescript_1 = require("json2typescript");
var query_string_1 = __importDefault(require("query-string"));
var jsonConvert = new json2typescript_1.JsonConvert();
var v1 = 1;
var v3 = 3;
var API_TYPE_PRIVATE = 'private';
var API_TYPE_ADMIN = 'admin';
var BaasAdminClient = (function () {
    function BaasAdminClient(baseUrl, options) {
        var _a, _b, _c;
        if (baseUrl === void 0) { baseUrl = Common_1.DEFAULT_BAAS_SERVER_URL; }
        if (options === void 0) { options = {}; }
        this.authUrl = "".concat(baseUrl, "/api/admin/v3.0/auth");
        this.rootURLsByAPIVersion = (_a = {},
            _a[v1] = (_b = {},
                _b[API_TYPE_PRIVATE] = "".concat(baseUrl, "/api/private/v1.0"),
                _b),
            _a[v3] = (_c = {},
                _c[API_TYPE_ADMIN] = "".concat(baseUrl, "/api/admin/v3.0"),
                _c),
            _a);
        var authOptions = {
            storage: options.storage,
        };
        if (options.requestOrigin) {
            authOptions.requestOrigin = options.requestOrigin;
        }
        this.auth = new auth_1.default(this, this.authUrl, authOptions);
        this.auth.handleCookie();
    }
    Object.defineProperty(BaasAdminClient.prototype, "_private", {
        get: function () {
            return this.apiMethods(API_TYPE_PRIVATE, v1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaasAdminClient.prototype, "_admin", {
        get: function () {
            return this.apiMethods(API_TYPE_ADMIN, v3);
        },
        enumerable: false,
        configurable: true
    });
    BaasAdminClient.prototype.authenticate = function (providerType, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var authenticateFn = function () {
            return _this.auth
                .provider(providerType)
                .authenticate(options)
                .then(function () { return _this.authedId(); });
        };
        if (this.isAuthenticated()) {
            return this.logout().then(function () { return authenticateFn(); });
        }
        return authenticateFn();
    };
    BaasAdminClient.prototype.logout = function () {
        var _this = this;
        return this._do('/auth/session', 'DELETE', {
            refreshOnFailure: false,
            useRefreshToken: true,
        }).then(function () { return _this.auth.clear(); }, function () { return _this.auth.clear(); });
    };
    BaasAdminClient.prototype.authError = function () {
        return this.auth.error;
    };
    BaasAdminClient.prototype.isAuthenticated = function () {
        return !!this.authedId();
    };
    BaasAdminClient.prototype.authedId = function () {
        return this.auth.authedId;
    };
    BaasAdminClient.prototype.doSessionPost = function () {
        return this._do('/auth/session', 'POST', {
            refreshOnFailure: false,
            useRefreshToken: true,
        }).then(function (response) { return response.json(); });
    };
    BaasAdminClient.prototype._fetch = function (url, fetchArgs, resource, method, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return fetch(url, fetchArgs).then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return Promise.resolve(response);
            }
            if (response.headers.get('Content-Type') === Common_1.JSONTYPE) {
                return response.json().then(function (json) {
                    if (!(0, Error_1.isRawErrorResponse)(json)) {
                        return Promise.reject(json);
                    }
                    var err = (0, Error_1.toErrorResponse)(json);
                    if (err.errorCode === Error_1.ErrInvalidSession) {
                        if (!options.refreshOnFailure) {
                            _this.auth.clear();
                            var serverErr = new Error_1.ServerError(err.error, err.errorCode);
                            serverErr.response = response;
                            serverErr.json = err;
                            throw serverErr;
                        }
                        return _this.auth.refreshToken().then(function () {
                            options.refreshOnFailure = false;
                            return _this._do(resource, method, options);
                        });
                    }
                    if (err.errorCode === Error_1.ErrUIIPRestricted) {
                        var serverErr = new Error_1.ServerError(err.error, err.errorCode);
                        serverErr.response = response;
                        serverErr.json = err;
                        throw serverErr;
                    }
                    var error = new Error_1.ServerError(err.error, err.errorCode);
                    error.response = response;
                    error.json = err;
                    return Promise.reject(error);
                });
            }
            var respErr = new Error_1.ResponseError(response.statusText);
            respErr.response = response;
            return Promise.reject(respErr);
        });
    };
    BaasAdminClient.prototype._fetchArgs = function (resource, method, options) {
        var _a, _b;
        var appURL = this.rootURLsByAPIVersion[(_a = options.apiVersion) !== null && _a !== void 0 ? _a : v3][(_b = options.apiType) !== null && _b !== void 0 ? _b : API_TYPE_ADMIN];
        var url = options.rootURL ? "".concat(options.rootURL).concat(resource) : "".concat(appURL).concat(resource);
        var fetchArgs = (0, Common_1.makeFetchArgs)(method, options);
        if (options.queryParams) {
            url = "".concat(url, "?").concat(query_string_1.default.stringify(options.queryParams));
        }
        return { url: url, fetchArgs: fetchArgs };
    };
    BaasAdminClient.prototype._do = function (resource, method, options) {
        if (options === void 0) { options = {}; }
        options = __assign({ apiType: API_TYPE_ADMIN, apiVersion: v3, refreshOnFailure: true, rootURL: undefined, useRefreshToken: false }, options);
        var token = options.useRefreshToken ? this.auth.getRefreshToken() : this.auth.getAccessToken();
        if (!options.headers) {
            options.headers = {};
        }
        if (this.auth.requestOrigin && !options.skipDraft) {
            options.headers['X-BAAS-Request-Origin'] = this.auth.requestOrigin;
        }
        if (!options.noAuth) {
            options.headers.Authorization = "Bearer ".concat(token);
        }
        var _a = this._fetchArgs(resource, method, options), url = _a.url, fetchArgs = _a.fetchArgs;
        if (options.noAuth) {
            return this._fetch(url, fetchArgs, resource, method, options);
        }
        if (!this.isAuthenticated()) {
            return Promise.reject(new Error_1.ServerError('Must auth first', Error_1.ErrUnauthorized));
        }
        return this._fetch(url, fetchArgs, resource, method, options);
    };
    BaasAdminClient.prototype.userProfile = function () {
        return this._admin._get('/auth/profile', User_1.UserProfile);
    };
    BaasAdminClient.prototype.getAuthProviders = function () {
        return this._do('/auth/providers', 'GET', {
            noAuth: true,
        })
            .then(function (response) { return response.text(); })
            .then(function (response) {
            return Object.values(bson_1.EJSON.parse(response)).map(function (val) {
                return jsonConvert.deserializeObject(val, AuthProvider_1.AuthProviderConfig);
            });
        });
    };
    BaasAdminClient.prototype.apps = function (groupId) {
        var api = this._admin;
        var groupUrl = "/groups/".concat(groupId, "/apps");
        return {
            measurements: function (request) {
                var filter = (0, Measurement_1.getMeasurementFilter)(request);
                return api._get("/groups/".concat(groupId, "/measurements"), Measurement_1.GroupMeasurementGroup, filter);
            },
            atlasAPIKeys: function () {
                return {
                    create: function (req) {
                        return api._post("/groups/".concat(groupId, "/api_keys"), AtlasAPIKey_1.CreateAtlasAPIKeyResponse, new AtlasAPIKey_1.CreateAtlasAPIKeyRequest(req));
                    },
                };
            },
            app: function (appId) {
                var appUrl = "".concat(groupUrl, "/").concat(appId);
                return {
                    get: function () { return api._get(appUrl, App_1.PartialApp); },
                    remove: function () { return api._delete(appUrl); },
                    export: function (version, deployment, sourceControl) {
                        if (version === void 0) { version = Deployment_1.AppConfig.Version20210101; }
                        return api._getUntyped("".concat(appUrl, "/export"), { version: version, deployment: deployment, source_control: sourceControl }, {
                            Accept: 'application/zip',
                        });
                    },
                    metrics: function (request) {
                        var filter = (0, Metric_1.getMetricsFilter)(request);
                        return api._get("".concat(appUrl, "/metrics"), Metric_1.AppMetrics, filter);
                    },
                    measurements: function (request) {
                        var filter = (0, Measurement_1.getMeasurementFilter)(request);
                        return api._get("".concat(appUrl, "/measurements"), Measurement_1.AppMeasurementGroup, filter);
                    },
                    commands: function () { return ({
                        run: function (command, data) {
                            return api._postUntyped("".concat(appUrl, "/commands/").concat(command), data);
                        },
                    }); },
                    dependencies: function () { return ({
                        delete: function (packageName) { return api._delete("".concat(appUrl, "/dependencies/").concat(encodeURIComponent(packageName))); },
                        deleteAll: function () { return api._delete("".concat(appUrl, "/dependencies")); },
                        list: function () { return api._get("".concat(appUrl, "/dependencies"), Dependencies_1.AppDependencies); },
                        put: function (filename, body) {
                            var form = new FormData();
                            form.append('file', body, filename);
                            return api._putRaw("".concat(appUrl, "/dependencies"), {
                                body: form,
                                multipart: true,
                            });
                        },
                        status: function () { return api._get("".concat(appUrl, "/dependencies/status"), Dependencies_1.DependencyInstallation); },
                        upload: function (filename, body) {
                            var form = new FormData();
                            form.append('file', body, filename);
                            return api._postRaw("".concat(appUrl, "/dependencies"), {
                                body: form,
                                multipart: true,
                            });
                        },
                        upsert: function (packageName, packageVersion) {
                            return api._put("".concat(appUrl, "/dependencies/").concat(encodeURIComponent(packageName)), undefined, {
                                version: packageVersion,
                            });
                        },
                    }); },
                    environment: function () { return ({
                        update: function (environment) { return api._put("".concat(appUrl, "/environment"), environment); },
                    }); },
                    environmentValues: function () { return ({
                        create: function (environmentValue) {
                            return api._post("".concat(appUrl, "/environment_values"), EnvironmentValue_1.EnvironmentValue, environmentValue);
                        },
                        list: function () { return api._list("".concat(appUrl, "/environment_values"), EnvironmentValue_1.PartialEnvironmentValue); },
                        environmentValue: function (environmentValueId) {
                            var environmentValueUrl = "".concat(appUrl, "/environment_values/").concat(environmentValueId);
                            return {
                                get: function () { return api._get(environmentValueUrl, EnvironmentValue_1.EnvironmentValue); },
                                remove: function () { return api._delete(environmentValueUrl); },
                                update: function (environmentValue) { return api._put(environmentValueUrl, environmentValue); },
                            };
                        },
                    }); },
                    templates: function () { return ({
                        get: function () { return api._list("".concat(appUrl, "/templates"), Template_1.Template); },
                        template: function (templateId) {
                            var templateUrl = "".concat(appUrl, "/templates/").concat(templateId);
                            return {
                                client: function () { return api._getUntyped("".concat(templateUrl, "/client")); },
                            };
                        },
                    }); },
                    values: function () { return ({
                        create: function (val) { return api._post("".concat(appUrl, "/values"), Value_1.PartialValue, val); },
                        list: function () { return api._list("".concat(appUrl, "/values"), Value_1.PartialValue); },
                        value: function (valueId) {
                            var valueUrl = "".concat(appUrl, "/values/").concat(valueId);
                            return {
                                get: function () { return api._get(valueUrl, Value_1.Value); },
                                remove: function () { return api._delete(valueUrl); },
                                update: function (val) { return api._put(valueUrl, val); },
                            };
                        },
                    }); },
                    secrets: function () { return ({
                        create: function (secret) { return api._post("".concat(appUrl, "/secrets"), Secret_1.PartialSecret, secret); },
                        list: function () { return api._list("".concat(appUrl, "/secrets"), Secret_1.PartialSecret); },
                        secret: function (secretId) {
                            var secretUrl = "".concat(appUrl, "/secrets/").concat(secretId);
                            return {
                                remove: function () { return api._delete(secretUrl); },
                                update: function (secret) { return api._put(secretUrl, secret); },
                            };
                        },
                    }); },
                    hosting: function () { return ({
                        assets: function () { return ({
                            asset: function (path) { return ({
                                delete: function () { return api._delete("".concat(appUrl, "/hosting/assets/asset"), { path: path }); },
                                get: function () {
                                    return api._get("".concat(appUrl, "/hosting/assets/asset"), Hosting_1.AssetMetadata, {
                                        path: path,
                                    });
                                },
                                patch: function (options) {
                                    return api._patchRaw("".concat(appUrl, "/hosting/assets/asset"), {
                                        body: JSON.stringify({ attributes: options.attributes }),
                                        queryParams: { path: path },
                                    });
                                },
                            }); },
                            createDirectory: function (folderName) {
                                return api._putRaw("".concat(appUrl, "/hosting/assets/asset"), {
                                    body: JSON.stringify({ path: "".concat(folderName, "/") }),
                                });
                            },
                            list: function (prefix, recursive) {
                                var filter = {};
                                if (prefix) {
                                    filter.prefix = prefix;
                                }
                                if (recursive) {
                                    filter.recursive = recursive;
                                }
                                return api._list("".concat(appUrl, "/hosting/assets"), Hosting_1.AssetMetadata, filter);
                            },
                            transform: function (request) { return api._postNoContent("".concat(appUrl, "/hosting/assets"), request); },
                            upload: function (metadata, body) {
                                var form = new FormData();
                                form.append('meta', JSON.stringify(jsonConvert.serialize(metadata)));
                                form.append('file', body);
                                return api._putRaw("".concat(appUrl, "/hosting/assets/asset"), {
                                    body: form,
                                    multipart: true,
                                });
                            },
                        }); },
                        cache: function () { return ({
                            invalidate: function (path) {
                                return api._putRaw("".concat(appUrl, "/hosting/cache"), {
                                    body: JSON.stringify({ invalidate: true, path: path }),
                                });
                            },
                        }); },
                        config: function () { return ({
                            get: function () { return api._get("".concat(appUrl, "/hosting/config"), Hosting_1.HostingConfig); },
                            patch: function (config) { return api._patch("".concat(appUrl, "/hosting/config"), config); },
                        }); },
                        presign: function () { return ({
                            get: function (path) {
                                return api._get("".concat(appUrl, "/hosting/presign"), Hosting_1.AssetURL, {
                                    path: path,
                                });
                            },
                        }); },
                    }); },
                    deploy: function () { return ({
                        auth: function () { return ({
                            github: function () {
                                return api._getUntyped("".concat(appUrl, "/deploy/github/auth"), undefined, undefined, {
                                    credentials: 'include',
                                });
                            },
                        }); },
                        config: function () { return api._get("".concat(appUrl, "/deploy/config"), CodeDeploy_1.PartialCodeDeploy); },
                        deployments: function () { return ({
                            get: function (commit) { return api._get("".concat(appUrl, "/deployments/").concat(commit), Deployment_1.Deployment); },
                            list: function (filter) {
                                var queryFilter;
                                if (filter) {
                                    queryFilter = {};
                                    if (filter.before) {
                                        queryFilter.before = filter.before;
                                    }
                                    if (filter.limit) {
                                        queryFilter.limit = filter.limit;
                                    }
                                    if (filter.draftId) {
                                        queryFilter.draft_id = filter.draftId;
                                    }
                                    if (filter.userId) {
                                        queryFilter.user_id = filter.userId;
                                    }
                                }
                                return api._list("".concat(appUrl, "/deployments"), Deployment_1.Deployment, filter);
                            },
                            deployment: function (deploymentId) { return ({
                                rename: function (name) {
                                    return api._patchRaw("".concat(appUrl, "/deployments/").concat(deploymentId, "/rename"), {
                                        body: JSON.stringify({ name: name }),
                                    });
                                },
                                redeploy: function () { return api._postUntyped("".concat(appUrl, "/deployments/").concat(deploymentId, "/redeploy")); },
                            }); },
                        }); },
                        installation: function () { return api._list("".concat(appUrl, "/deploy/installation"), CodeDeploy_1.Installation); },
                        overwriteConfig: function (config) { return api._put("".concat(appUrl, "/deploy/config"), config); },
                        repositories: function () { return ({
                            repository: function (repoId) { return ({
                                github: function () { return ({
                                    branches: function () { return ({
                                        list: function () { return api._list("".concat(appUrl, "/deploy/github/repositories/").concat(repoId, "/branches"), CodeDeploy_1.GitHubBranch); },
                                    }); },
                                }); },
                            }); },
                        }); },
                        updateConfig: function (config) { return api._patch("".concat(appUrl, "/deploy/config"), config); },
                        push: function () { return ({
                            github: function (request, bypassServiceChange) {
                                var queryParams;
                                if (bypassServiceChange) {
                                    queryParams = { bypass_service_change: bypassServiceChange };
                                }
                                return api._postNoContent("".concat(appUrl, "/deploy/github/push"), request, queryParams);
                            },
                        }); },
                        ttlInstallations: function (installationId) { return ({
                            enableAutoDeploy: function (request) {
                                return api._postNoContent("".concat(appUrl, "/deploy/github/ttl_installations/").concat(installationId, "/enable_auto_deploy"), request);
                            },
                        }); },
                    }); },
                    drafts: function () { return ({
                        create: function () { return api._post("".concat(appUrl, "/drafts"), Draft_1.PartialDraft); },
                        delete: function (draftId) { return api._delete("".concat(appUrl, "/drafts/").concat(draftId)); },
                        deploy: function (draftId, bypassServiceChange, deploymentName) {
                            var filter;
                            if (bypassServiceChange) {
                                filter = { bypass_service_change: bypassServiceChange };
                            }
                            return api._post("".concat(appUrl, "/drafts/").concat(draftId, "/deployment"), Deployment_1.Deployment, new Deployment_1.DeployDraftPayload({ name: deploymentName }), filter);
                        },
                        diff: function (draftId) { return api._get("".concat(appUrl, "/drafts/").concat(draftId, "/diff"), Draft_1.DraftDiff); },
                        get: function (draftId) { return api._get("".concat(appUrl, "/drafts/").concat(draftId), Draft_1.PartialDraft); },
                        list: function () { return api._list("".concat(appUrl, "/drafts"), Draft_1.PartialDraft); },
                    }); },
                    services: function () { return ({
                        create: function (desc, skipDraft) {
                            if (skipDraft === void 0) { skipDraft = false; }
                            return api._post("".concat(appUrl, "/services"), Service_1.PartialServiceDesc, new Service_1.ServiceDesc(desc), undefined, {
                                skipDraft: skipDraft,
                            });
                        },
                        list: function () { return api._list("".concat(appUrl, "/services"), Service_1.PartialServiceDesc); },
                        service: function (serviceId) { return ({
                            documentFields: function () { return api._list("".concat(appUrl, "/services/").concat(serviceId, "/document_fields"), String); },
                            config: function () { return ({
                                get: function () { return api._getUntyped("".concat(appUrl, "/services/").concat(serviceId, "/config")); },
                                getWithSecrets: function () {
                                    return api._get("".concat(appUrl, "/services/").concat(serviceId, "/config"), Service_1.ServiceDescConfig, {
                                        includeSecretConfig: true,
                                    });
                                },
                                update: function (config, bypassServiceChange) {
                                    var filter;
                                    if (bypassServiceChange) {
                                        filter = { bypass_service_change: bypassServiceChange };
                                    }
                                    return api._patchRaw("".concat(appUrl, "/services/").concat(serviceId, "/config"), {
                                        body: JSON.stringify(config),
                                        queryParams: filter,
                                    });
                                },
                                updateWithSecrets: function (config) {
                                    return api._patch("".concat(appUrl, "/services/").concat(serviceId, "/config"), config);
                                },
                            }); },
                            get: function () { return api._get("".concat(appUrl, "/services/").concat(serviceId), Service_1.PartialServiceDesc); },
                            incomingWebhooks: function () { return ({
                                create: function (webhook) {
                                    return api._post("".concat(appUrl, "/services/").concat(serviceId, "/incoming_webhooks"), IncomingWebhook_1.PartialIncomingWebhook, webhook);
                                },
                                incomingWebhook: function (incomingWebhookId) {
                                    var webhookUrl = "".concat(appUrl, "/services/").concat(serviceId, "/incoming_webhooks/").concat(incomingWebhookId);
                                    return {
                                        get: function () { return api._get(webhookUrl, IncomingWebhook_1.IncomingWebhook); },
                                        remove: function () { return api._delete(webhookUrl); },
                                        update: function (webhook) { return api._put(webhookUrl, webhook); },
                                    };
                                },
                                list: function () { return api._list("".concat(appUrl, "/services/").concat(serviceId, "/incoming_webhooks"), IncomingWebhook_1.PartialIncomingWebhook); },
                            }); },
                            remove: function (bypassServiceChange) {
                                var filter;
                                if (bypassServiceChange) {
                                    filter = { bypass_service_change: bypassServiceChange };
                                }
                                return api._delete("".concat(appUrl, "/services/").concat(serviceId), filter);
                            },
                            defaultRule: function () {
                                var defaultRuleUrl = "".concat(appUrl, "/services/").concat(serviceId, "/default_rule");
                                return {
                                    get: function () { return api._getConvert(Rule_1.deserializeBaseRule, defaultRuleUrl); },
                                    create: function (defaultRule, bypassServiceChange) {
                                        var filter;
                                        if (bypassServiceChange) {
                                            filter = { bypass_service_change: bypassServiceChange };
                                        }
                                        return api._postConvert(defaultRuleUrl, defaultRule, Rule_1.deserializeBaseRule, filter);
                                    },
                                    remove: function () {
                                        return api._delete(defaultRuleUrl);
                                    },
                                    update: function (defaultRule, bypassServiceChange) {
                                        var filter;
                                        if (bypassServiceChange) {
                                            filter = { bypass_service_change: bypassServiceChange };
                                        }
                                        return api._put(defaultRuleUrl, defaultRule, filter);
                                    },
                                    namespaces: function () {
                                        return api._list("".concat(defaultRuleUrl, "/namespaces"), Rule_1.MongoDBNamespace);
                                    },
                                };
                            },
                            rules: function () {
                                var rulesUrl = "".concat(appUrl, "/services/").concat(serviceId, "/rules");
                                return {
                                    create: function (rule, bypassServiceChange) {
                                        var filter;
                                        if (bypassServiceChange) {
                                            filter = { bypass_service_change: bypassServiceChange };
                                        }
                                        return api._postConvert(rulesUrl, rule, Rule_1.deserializePartialRule, filter);
                                    },
                                    list: function () { return api._listConvert(rulesUrl, Rule_1.deserializePartialRule); },
                                    remove: function (databaseName) {
                                        var filter;
                                        if (databaseName) {
                                            filter = { database: databaseName };
                                        }
                                        return api._delete(rulesUrl, filter);
                                    },
                                    rule: function (ruleId) {
                                        var ruleUrl = "".concat(rulesUrl, "/").concat(ruleId);
                                        return {
                                            get: function () { return api._getConvert(Rule_1.deserializeRule, ruleUrl); },
                                            remove: function (bypassServiceChange) {
                                                var filter;
                                                if (bypassServiceChange) {
                                                    filter = { bypass_service_change: bypassServiceChange };
                                                }
                                                return api._delete(ruleUrl, filter);
                                            },
                                            update: function (rule, bypassServiceChange) {
                                                var filter;
                                                if (bypassServiceChange) {
                                                    filter = { bypass_service_change: bypassServiceChange };
                                                }
                                                return api._put(ruleUrl, rule, filter);
                                            },
                                        };
                                    },
                                    syncIncompatibleRoles: function () {
                                        return api._get("".concat(rulesUrl, "/sync_incompatible_roles"), Rule_1.MongoDBSyncIncompatibleRoles);
                                    },
                                };
                            },
                            runCommand: function (commandName, data) {
                                return api._postUntyped("".concat(appUrl, "/services/").concat(serviceId, "/commands/").concat(commandName), data);
                            },
                            update: function (version) {
                                return api
                                    ._patchRaw("".concat(appUrl, "/services/").concat(serviceId), {
                                    body: JSON.stringify({ version: version }),
                                })
                                    .then(function (response) { return response.text(); })
                                    .then(function (response) { return jsonConvert.deserializeObject(bson_1.EJSON.parse(response), Service_1.PartialServiceDesc); });
                            },
                        }); },
                    }); },
                    endpoints: function () { return ({
                        create: function (endpoint) { return api._post("".concat(appUrl, "/endpoints"), Endpoint_1.PartialEndpoint, endpoint); },
                        list: function () { return api._list("".concat(appUrl, "/endpoints"), Endpoint_1.PartialEndpoint); },
                        endpoint: function (endpointId) { return ({
                            get: function () { return api._get("".concat(appUrl, "/endpoints/").concat(endpointId), Endpoint_1.Endpoint); },
                            remove: function () { return api._delete("".concat(appUrl, "/endpoints/").concat(endpointId)); },
                            update: function (endpoint) { return api._put("".concat(appUrl, "/endpoints/").concat(endpointId), endpoint); },
                        }); },
                        convert: function (request) {
                            var filter;
                            if (request) {
                                filter = {};
                                if (request.strategy) {
                                    filter.strategy = request.strategy;
                                }
                            }
                            return api._put("".concat(appUrl, "/endpoints/convert"), undefined, filter);
                        },
                    }); },
                    pushNotifications: function () { return ({
                        create: function (request) {
                            return api._post("".concat(appUrl, "/push/notifications"), Push_1.PushNotification, request);
                        },
                        list: function (state) {
                            return api._list("".concat(appUrl, "/push/notifications"), Push_1.PushNotification, {
                                state: state,
                            });
                        },
                        pushNotification: function (messageId) { return ({
                            get: function () { return api._get("".concat(appUrl, "/push/notifications/").concat(messageId), Push_1.PushNotification); },
                            remove: function () { return api._delete("".concat(appUrl, "/push/notifications/").concat(messageId)); },
                            send: function () { return api._postUntyped("".concat(appUrl, "/push/notifications/").concat(messageId, "/send")); },
                            update: function (request) {
                                return api._put("".concat(appUrl, "/push/notifications/").concat(messageId), request);
                            },
                        }); },
                    }); },
                    users: function () { return ({
                        count: function () { return api._getUntyped("".concat(appUrl, "/users_count")).then(function (result) { return result; }); },
                        create: function (request) { return api._post("".concat(appUrl, "/users"), User_1.PartialUser, request); },
                        list: function (filter) {
                            var queryFilter;
                            if (filter) {
                                queryFilter = {};
                                if (filter.descending) {
                                    queryFilter.desc = filter.descending;
                                }
                                if (filter.after) {
                                    queryFilter.after = filter.after;
                                }
                                if (filter.providerTypes) {
                                    queryFilter.provider_types = filter.providerTypes;
                                }
                                if (filter.sort) {
                                    queryFilter.sort = filter.sort;
                                }
                                if (filter.limit) {
                                    queryFilter.limit = filter.limit;
                                }
                            }
                            return api._list("".concat(appUrl, "/users"), User_1.PartialUser, filter);
                        },
                        user: function (uid) { return ({
                            devices: function () { return ({
                                get: function () { return api._list("".concat(appUrl, "/users/").concat(uid, "/devices"), User_1.Device); },
                            }); },
                            disable: function () { return api._putRaw("".concat(appUrl, "/users/").concat(uid, "/disable")); },
                            enable: function () { return api._putRaw("".concat(appUrl, "/users/").concat(uid, "/enable")); },
                            get: function () { return api._get("".concat(appUrl, "/users/").concat(uid), User_1.User); },
                            logout: function () { return api._putRaw("".concat(appUrl, "/users/").concat(uid, "/logout")); },
                            remove: function () { return api._delete("".concat(appUrl, "/users/").concat(uid)); },
                        }); },
                    }); },
                    userRegistrations: function () { return ({
                        confirmByEmail: function (email) {
                            return api._postUntyped("".concat(appUrl, "/user_registrations/by_email/").concat(email, "/confirm"));
                        },
                        listPending: function (limit, after) {
                            var filter;
                            if (limit || after) {
                                filter = {};
                                if (limit) {
                                    filter.limit = limit;
                                }
                                if (after) {
                                    filter.after = after;
                                }
                            }
                            api._list("".concat(appUrl, "/user_registrations/pending_users"), User_1.PasswordRecord, filter);
                        },
                        removePendingUserByEmail: function (email) { return api._delete("".concat(appUrl, "/user_registrations/by_email/").concat(email)); },
                        removePendingUserByID: function (id) { return api._delete("".concat(appUrl, "/user_registrations/by_id/").concat(id)); },
                        runUserConfirmation: function (email) {
                            return api._post("".concat(appUrl, "/user_registrations/by_email/").concat(email, "/run_confirm"), User_1.UserActionToken);
                        },
                        sendConfirmationEmail: function (email) {
                            return api._post("".concat(appUrl, "/user_registrations/by_email/").concat(email, "/send_confirm"), User_1.UserActionToken);
                        },
                    }); },
                    customUserData: function () { return ({
                        get: function () { return api._get("".concat(appUrl, "/custom_user_data"), UserSettings_1.CustomUserDataConfig); },
                        update: function (config) { return api._patch("".concat(appUrl, "/custom_user_data"), config); },
                    }); },
                    debug: function () { return ({
                        executeFunction: function (userId, name) {
                            if (name === void 0) { name = ''; }
                            var args = [];
                            for (var _i = 2; _i < arguments.length; _i++) {
                                args[_i - 2] = arguments[_i];
                            }
                            return api._postTypedJSON("".concat(appUrl, "/debug/execute_function"), DebugExecuteFunction_1.DebugExecuteFunctionResponse, new DebugExecuteFunction_1.DebugExecuteFunctionRequest({ name: name, arguments: args }), { user_id: userId });
                        },
                        executeFunctionSource: function (_a) {
                            var userId = _a.userId, _b = _a.source, source = _b === void 0 ? '' : _b, _c = _a.evalSource, evalSource = _c === void 0 ? '' : _c, runAsSystem = _a.runAsSystem;
                            return api._postTypedJSON("".concat(appUrl, "/debug/execute_function_source"), DebugExecuteFunction_1.DebugExecuteFunctionResponse, new DebugExecuteFunction_1.DebugExecuteFunctionSourceRequest({ source: source, evalSource: evalSource }), { user_id: userId, run_as_system: runAsSystem });
                        },
                    }); },
                    authProviders: function () { return ({
                        authProvider: function (providerId) { return ({
                            disable: function () { return api._putRaw("".concat(appUrl, "/auth_providers/").concat(providerId, "/disable")); },
                            enable: function () { return api._putRaw("".concat(appUrl, "/auth_providers/").concat(providerId, "/enable")); },
                            get: function () { return api._get("".concat(appUrl, "/auth_providers/").concat(providerId), AuthProvider_1.AuthProviderConfig); },
                            getDeployed: function () { return api._get("".concat(appUrl, "/auth_providers/").concat(providerId, "/deployed"), AuthProvider_1.AuthProviderConfig); },
                            remove: function () { return api._delete("".concat(appUrl, "/auth_providers/").concat(providerId)); },
                            update: function (config) { return api._patch("".concat(appUrl, "/auth_providers/").concat(providerId), config); },
                        }); },
                        create: function (config) {
                            return api._post("".concat(appUrl, "/auth_providers"), AuthProvider_1.PartialAuthProviderConfig, config);
                        },
                        list: function () { return api._list("".concat(appUrl, "/auth_providers"), AuthProvider_1.PartialAuthProviderConfig); },
                    }); },
                    security: function () { return ({
                        allowedRequestOrigins: function () { return ({
                            get: function () { return api._list("".concat(appUrl, "/security/allowed_request_origins"), String); },
                            update: function (origins) { return api._postUntyped("".concat(appUrl, "/security/allowed_request_origins"), origins); },
                        }); },
                        accessList: function () { return ({
                            create: function (allowedIP) {
                                return api._post("".concat(appUrl, "/security/access_list"), IPAccess_1.ListedAllowedIP, allowedIP);
                            },
                            get: function () { return api._get("".concat(appUrl, "/security/access_list"), IPAccess_1.AccessList); },
                            allowedIP: function (ipID) {
                                var allowedIPUrl = "".concat(appUrl, "/security/access_list/").concat(ipID);
                                return {
                                    update: function (allowedIP) { return api._patchTyped(allowedIPUrl, IPAccess_1.ListedAllowedIP, allowedIP); },
                                    delete: function () { return api._delete(allowedIPUrl); },
                                };
                            },
                        }); },
                        refreshTokenExpiration: function () { return ({
                            get: function () { return api._get("".concat(appUrl, "/security/refresh_token_expiration"), UserSettings_1.RefreshTokenExpirationPayload); },
                            update: function (expirationTime) {
                                return api._put("".concat(appUrl, "/security/refresh_token_expiration"), expirationTime);
                            },
                        }); },
                    }); },
                    logs: function () { return ({
                        list: function (request) {
                            var filter = (0, Log_1.getLogFilter)(request);
                            return api._get("".concat(appUrl, "/logs"), Log_1.AppLogResponse, filter);
                        },
                        download: function (request) {
                            var filter = (0, Log_1.getLogFilter)(request);
                            return api._getUntyped("".concat(appUrl, "/logs/download"), filter, {
                                Accept: 'application/zip',
                            });
                        },
                    }); },
                    logForwarders: function () { return ({
                        list: function () { return api._list("".concat(appUrl, "/log_forwarders"), LogForwarder_1.LogForwarder); },
                        create: function (logForwarder) {
                            return api._post("".concat(appUrl, "/log_forwarders"), LogForwarder_1.LogForwarder, logForwarder);
                        },
                        logForwarder: function (logForwarderId) { return ({
                            get: function () { return api._get("".concat(appUrl, "/log_forwarders/").concat(logForwarderId), LogForwarder_1.LogForwarder); },
                            remove: function () { return api._delete("".concat(appUrl, "/log_forwarders/").concat(logForwarderId)); },
                            enable: function () { return api._putRaw("".concat(appUrl, "/log_forwarders/").concat(logForwarderId, "/enable")); },
                            disable: function () { return api._putRaw("".concat(appUrl, "/log_forwarders/").concat(logForwarderId, "/disable")); },
                            update: function (logForwarder) {
                                return api._patchTyped("".concat(appUrl, "/log_forwarders/").concat(logForwarderId), LogForwarder_1.LogForwarder, logForwarder);
                            },
                            resume: function () { return api._putRaw("".concat(appUrl, "/log_forwarders/").concat(logForwarderId, "/resume")); },
                        }); },
                    }); },
                    apiKeys: function () { return ({
                        apiKey: function (apiKeyId) { return ({
                            disable: function () { return api._putRaw("".concat(appUrl, "/api_keys/").concat(apiKeyId, "/disable")); },
                            enable: function () { return api._putRaw("".concat(appUrl, "/api_keys/").concat(apiKeyId, "/enable")); },
                            get: function () { return api._get("".concat(appUrl, "/api_keys/").concat(apiKeyId), APIKey_1.PartialAPIKey); },
                            remove: function () { return api._delete("".concat(appUrl, "/api_keys/").concat(apiKeyId)); },
                        }); },
                        create: function (key) { return api._post("".concat(appUrl, "/api_keys"), APIKey_1.APIKey, key); },
                        list: function () { return api._list("".concat(appUrl, "/api_keys"), APIKey_1.PartialAPIKey); },
                    }); },
                    functions: function () { return ({
                        create: function (func) { return api._post("".concat(appUrl, "/functions"), Function_1.PartialAppFunction, func); },
                        function: function (functionId) { return ({
                            get: function () { return api._get("".concat(appUrl, "/functions/").concat(functionId), Function_1.ClientAppFunction); },
                            remove: function () { return api._delete("".concat(appUrl, "/functions/").concat(functionId)); },
                            update: function (func) { return api._put("".concat(appUrl, "/functions/").concat(functionId), func); },
                        }); },
                        list: function () { return api._list("".concat(appUrl, "/functions"), Function_1.PartialAppFunction); },
                    }); },
                    eventSubscriptions: function () { return ({
                        create: function (sub) { return api._post("".concat(appUrl, "/event_subscriptions"), EventSubscription_1.EventSubscription, sub); },
                        eventSubscription: function (eventSubscriptionId) { return ({
                            get: function () { return api._get("".concat(appUrl, "/event_subscriptions/").concat(eventSubscriptionId), EventSubscription_1.EventSubscription); },
                            remove: function () { return api._delete("".concat(appUrl, "/event_subscriptions/").concat(eventSubscriptionId)); },
                            resume: function (options) {
                                return api._put("".concat(appUrl, "/event_subscriptions/").concat(eventSubscriptionId, "/resume"), options);
                            },
                            update: function (sub) { return api._put("".concat(appUrl, "/event_subscriptions/").concat(eventSubscriptionId), sub); },
                            execution: function () {
                                return api._get("".concat(appUrl, "/event_subscriptions/").concat(eventSubscriptionId, "/execution"), EventSubscription_1.EventSubscriptionExecution);
                            },
                        }); },
                        list: function (type) {
                            var filter;
                            if (type) {
                                filter = { type: type };
                            }
                            return api._list("".concat(appUrl, "/event_subscriptions"), EventSubscription_1.EventSubscription, filter);
                        },
                    }); },
                    validationSettings: function () {
                        var validationSettingsUrl = "".concat(appUrl, "/validation_settings");
                        return {
                            graphql: function () {
                                var graphqlUrl = "".concat(validationSettingsUrl, "/graphql");
                                return {
                                    get: function () { return api._get(graphqlUrl, ValidationOptions_1.ValidationOptions); },
                                    update: function (settings) { return api._put(graphqlUrl, settings); },
                                };
                            },
                            nullTypeSchemaValidation: function () {
                                var nullTypeSchemaValUrl = "".concat(validationSettingsUrl, "/null_type_schema_validation");
                                return {
                                    get: function () { return api._get(nullTypeSchemaValUrl, ValidationOptions_1.NullTypeSchemaValidationSetting); },
                                    update: function (setting) { return api._put(nullTypeSchemaValUrl, setting); },
                                };
                            },
                        };
                    },
                    graphql: function () {
                        var graphqlUrl = "".concat(appUrl, "/graphql");
                        return {
                            config: function () { return ({
                                get: function () { return api._get("".concat(graphqlUrl, "/config"), GraphQL_1.GraphQLConfig); },
                                update: function (config) { return api._put("".concat(graphqlUrl, "/config"), config); },
                            }); },
                            customResolvers: function () { return ({
                                create: function (resolver) {
                                    return api._post("".concat(graphqlUrl, "/custom_resolvers"), GraphQL_1.CustomResolver, resolver);
                                },
                                customResolver: function (id) { return ({
                                    get: function () { return api._get("".concat(graphqlUrl, "/custom_resolvers/").concat(id), GraphQL_1.CustomResolver); },
                                    remove: function () { return api._delete("".concat(graphqlUrl, "/custom_resolvers/").concat(id)); },
                                    update: function (resolver) { return api._put("".concat(graphqlUrl, "/custom_resolvers/").concat(id), resolver); },
                                }); },
                                list: function () { return api._list("".concat(graphqlUrl, "/custom_resolvers"), GraphQL_1.CustomResolver); },
                            }); },
                            post: function (data) { return api._postUntyped("".concat(graphqlUrl), data); },
                            validate: function () { return api._list("".concat(graphqlUrl, "/validate"), GraphQL_1.GraphQLAlerts); },
                            extendableTypes: function () { return api._get("".concat(graphqlUrl, "/extendable_types"), GraphQL_1.ExtendableTypes); },
                        };
                    },
                    sync: function () {
                        var syncUrl = "".concat(appUrl, "/sync");
                        return {
                            clientSchemas: function () {
                                var clientSchemasUrl = "".concat(syncUrl, "/client_schemas");
                                return {
                                    get: function (language, namespaces) {
                                        var filter;
                                        if (namespaces && namespaces.length > 0) {
                                            filter = { namespace: namespaces };
                                        }
                                        return api._list("".concat(clientSchemasUrl, "/").concat(language), Sync_1.SyncClientSchema, filter);
                                    },
                                };
                            },
                            config: function () {
                                var configUrl = "".concat(syncUrl, "/config");
                                return {
                                    get: function () { return api._get(configUrl, Sync_1.SyncConfig); },
                                    update: function (config) { return api._put(configUrl, config); },
                                };
                            },
                            data: function (serviceId) {
                                var filter;
                                if (serviceId) {
                                    filter = { service_id: serviceId };
                                }
                                return api._get("".concat(syncUrl, "/data"), Sync_1.SyncData, filter);
                            },
                            allowedQueryableFields: function (serviceId) {
                                var queryableFieldUrl = "".concat(appUrl, "/services/").concat(serviceId, "/sync/allowed_queryable_fields");
                                return api._getConvert(function (response) {
                                    return new Sync_1.AllowedQueryableFields(response);
                                }, queryableFieldUrl);
                            },
                            allowedAsymmetricTables: function (serviceId) {
                                var asymmetricTableUrl = "".concat(appUrl, "/services/").concat(serviceId, "/sync/allowed_asymmetric_tables");
                                return api._getConvert(function (response) {
                                    return new Sync_1.AllowedAsymmetricTables(response);
                                }, asymmetricTableUrl);
                            },
                            progress: function () { return api._get("".concat(syncUrl, "/progress"), Sync_1.SyncProgress); },
                            schemas: function () { return ({
                                patch: function (request) { return api._patch("".concat(syncUrl, "/schemas"), request); },
                            }); },
                            state: function () {
                                return {
                                    get: function (syncType) { return api._get("".concat(syncUrl, "/state"), Sync_1.SyncState, { sync_type: syncType }); },
                                    patch: function (request) { return api._patch("".concat(syncUrl, "/state"), request); },
                                };
                            },
                            migration: function () {
                                var migrationUrl = "".concat(syncUrl, "/migration");
                                return {
                                    precheck: function () { return api._get("".concat(migrationUrl, "/precheck"), Sync_1.SyncMigrationPrecheck); },
                                    status: function () { return api._get(migrationUrl, Sync_1.SyncMigrationStatus); },
                                    put: function (req) { return api._put(migrationUrl, req); },
                                };
                            },
                        };
                    },
                    schemas: function () { return ({
                        create: function (schema, bypassServiceChange) {
                            var filter;
                            if (bypassServiceChange) {
                                filter = { bypass_service_change: bypassServiceChange };
                            }
                            return api._post("".concat(appUrl, "/schemas"), Schema_1.Schema, schema, filter);
                        },
                        list: function () { return api._list("".concat(appUrl, "/schemas"), Schema_1.PartialSchema); },
                        remove: function (dataSource, database) {
                            return api._delete("".concat(appUrl, "/schemas"), { data_source: dataSource, database: database });
                        },
                        schema: function (schemaId) {
                            var schemaUrl = "".concat(appUrl, "/schemas/").concat(schemaId);
                            return {
                                get: function () { return api._get(schemaUrl, Schema_1.Schema); },
                                remove: function (bypassServiceChange) {
                                    var filter;
                                    if (bypassServiceChange) {
                                        filter = { bypass_service_change: bypassServiceChange };
                                    }
                                    return api._delete(schemaUrl, filter);
                                },
                                update: function (schema, bypassServiceChange) {
                                    var filter;
                                    if (bypassServiceChange) {
                                        filter = { bypass_service_change: bypassServiceChange };
                                    }
                                    return api._put(schemaUrl, schema, filter);
                                },
                            };
                        },
                        bulkGenerateSchema: function (request) {
                            return api._postNoContent("".concat(appUrl, "/generate/schemas"), new Schema_1.GenerateSchemasRequest(request));
                        },
                    }); },
                    dataAPI: function () { return ({
                        config: function () {
                            var dataAPIConfigUrl = "".concat(appUrl, "/data_api/config");
                            return {
                                get: function () { return api._get(dataAPIConfigUrl, DataAPI_1.DataAPIConfig); },
                                create: function (config) { return api._post(dataAPIConfigUrl, DataAPI_1.DataAPIConfig, config); },
                                update: function (config) { return api._patch(dataAPIConfigUrl, config); },
                            };
                        },
                    }); },
                    deploymentMigration: function () {
                        var deploymentMigrationUrl = "".concat(appUrl, "/deployment_migration");
                        return {
                            put: function (deploymentMigration) {
                                return api._put(deploymentMigrationUrl, deploymentMigration);
                            },
                            get: function () { return api._get(deploymentMigrationUrl, DeploymentMigration_1.DeploymentMigrationStatus); },
                        };
                    },
                };
            },
            deploy: function () {
                var groupDeployUrl = "/groups/".concat(groupId, "/deploy");
                return {
                    auth: function () { return ({
                        github: function () {
                            return api._get("".concat(groupDeployUrl, "/github/auth"), CodeDeploy_1.GithubGroupAuthenticationResponse, undefined, undefined, {
                                credentials: 'include',
                            });
                        },
                    }); },
                    installationRequest: function (requestId) {
                        return api._list("".concat(groupDeployUrl, "/installation_request/").concat(requestId), CodeDeploy_1.Installation);
                    },
                    ttlInstallations: function (installationId) {
                        var ttlInstallationUrl = "".concat(groupDeployUrl, "/github/ttl_installations/").concat(installationId);
                        return {
                            repository: function (repoId) { return ({
                                github: function () { return ({
                                    branches: function () {
                                        var branchesUrl = "".concat(ttlInstallationUrl, "/repositories/").concat(repoId, "/branches");
                                        return {
                                            branch: function (branchName) { return ({
                                                directories: function () { return ({
                                                    list: function (githubAuthRequestId) {
                                                        return api._postUntyped("".concat(branchesUrl, "/").concat(branchName), {
                                                            github_auth_request_id: githubAuthRequestId,
                                                        });
                                                    },
                                                }); },
                                            }); },
                                            list: function (githubAuthRequestId) {
                                                return api._postUntyped("".concat(branchesUrl), { github_auth_request_id: githubAuthRequestId });
                                            },
                                        };
                                    },
                                }); },
                            }); },
                        };
                    },
                };
            },
            create: function (request) {
                var query = request.product ? "?product=".concat(request.product) : '';
                return api._post(groupUrl + query, App_1.PartialApp, request);
            },
            list: function (product) { return api._list(groupUrl, App_1.PartialApp, product ? { product: product } : undefined); },
        };
    };
    BaasAdminClient.prototype.templates = function () {
        var api = this._admin;
        return {
            list: function () { return api._list('/templates', Template_1.Template); },
        };
    };
    BaasAdminClient.prototype.dataAPI = function () {
        var api = this._admin;
        return {
            versions: function () { return ({
                list: function () { return api._list("/data_api/versions", String); },
            }); },
        };
    };
    BaasAdminClient.prototype.rules = function () {
        var api = this._admin;
        var rulesUrl = '/rules';
        return {
            presetRoles: function () { return ({
                list: function () { return api._list("".concat(rulesUrl, "/preset_roles"), Rule_1.PresetRole); },
            }); },
        };
    };
    BaasAdminClient.prototype.providerRegions = function () {
        var api = this._admin;
        var providerRegionsUrl = '/provider_regions';
        return {
            list: function () { return api._list(providerRegionsUrl, ProviderRegionData_1.ProviderRegionData); },
            nearest: function () {
                return {
                    get: function () { return api._get("".concat(providerRegionsUrl, "/nearest"), ProviderRegionData_1.NearestProviderRegion); },
                };
            },
        };
    };
    BaasAdminClient.prototype.private = function () {
        var privateApi = this._private;
        return {
            defaultM0ClusterVersion: function () {
                var defaultM0ClusterVersionUrl = '/default_m0_version';
                return {
                    get: function () { return privateApi._getUntyped(defaultM0ClusterVersionUrl); },
                };
            },
            auth: function () { return ({
                tempAPIKeys: function () {
                    var apiKeysUrl = '/auth/temp_api_keys';
                    return {
                        create: function (request) {
                            return privateApi._post(apiKeysUrl, TempAPIKey_1.CreateTempAPIKeyResponse, request);
                        },
                    };
                },
            }); },
            group: function (groupId) {
                var groupUrl = "/groups/".concat(groupId);
                return {
                    metrics: function (request) {
                        var filter = (0, Metric_1.getMetricsFilter)(request);
                        return privateApi._get("".concat(groupUrl, "/metrics"), Metric_1.GroupMetrics, filter);
                    },
                    app: function (appId) {
                        var appUrl = "".concat(groupUrl, "/apps/").concat(appId);
                        return {
                            atlasClusters: function () {
                                var clustersUrl = "".concat(appUrl, "/atlas_clusters");
                                return {
                                    create: function (regionName) {
                                        return privateApi._post(clustersUrl, AtlasCluster_1.CreateAtlasClusterResponse, new AtlasCluster_1.CreateAtlasClusterRequest({ regionName: regionName }), undefined, { credentials: 'include' });
                                    },
                                };
                            },
                            generate: function (template) { return privateApi._postUntyped("".concat(appUrl, "/generate"), { template_id: template }); },
                            settings: function () {
                                return {
                                    get: function () {
                                        return privateApi._get("".concat(appUrl, "/settings"), AppSettings_1.AppSettings);
                                    },
                                };
                            },
                            features: function () {
                                return {
                                    get: function (status) {
                                        return privateApi._get("".concat(appUrl, "/features").concat(status ? "?status=".concat(status) : ''), AppSettings_1.FeatureSettings);
                                    },
                                };
                            },
                        };
                    },
                    atlasClusters: function () {
                        var clustersUrl = "".concat(groupUrl, "/atlas_clusters");
                        return {
                            list: function () { return privateApi._list(clustersUrl, AtlasCluster_1.AtlasCluster); },
                            cluster: function (clusterName) {
                                var clusterUrl = "".concat(clustersUrl, "/").concat(clusterName);
                                return {
                                    get: function (fields) {
                                        var query = fields ? "?fields=".concat(fields.join(',')) : '';
                                        return privateApi._get(clusterUrl + query, AtlasCluster_1.AtlasCluster);
                                    },
                                    storageMetrics: function () {
                                        var clusterStorageMetricsUrl = "".concat(clusterUrl, "/storage_metrics");
                                        return {
                                            get: function () { return privateApi._get(clusterStorageMetricsUrl, ClusterStorageMetrics_1.ClusterStorageMetrics); },
                                        };
                                    },
                                };
                            },
                        };
                    },
                    atlasDataLakes: function (atlasProduct) {
                        var dataLakesUrl = "".concat(groupUrl, "/atlas_datalakes").concat(atlasProduct ? "?atlas_product=".concat(atlasProduct) : '');
                        return {
                            list: function () { return privateApi._list(dataLakesUrl, AtlasDataLake_1.AtlasDataLake); },
                        };
                    },
                    atlasServerlessInstances: function () {
                        var serverlessInstancesUrl = "".concat(groupUrl, "/atlas_serverless_instances");
                        return {
                            list: function () { return privateApi._list(serverlessInstancesUrl, AtlasCluster_1.AtlasCluster); },
                        };
                    },
                    get: function () { return privateApi._get(groupUrl, AtlasGroup_1.AtlasGroup); },
                };
            },
            spa: function () { return ({
                recaptcha: function () { return ({
                    verify: function (token) {
                        return privateApi._postRaw("/spa/recaptcha/verify", {
                            credentials: 'include',
                            multipart: true,
                            noAuth: true,
                            body: new URLSearchParams("response=".concat(token)),
                        });
                    },
                }); },
                settings: function () { return ({
                    global: function (auid) { return privateApi._getUntyped("/spa/settings/global", auid ? { auid: auid } : undefined); },
                }); },
            }); },
            provider: function (provider) {
                var providerUrl = "/provider/".concat(provider);
                return {
                    atlasRegions: function (atlasRegion) {
                        var atlasRegions = "".concat(providerUrl, "/atlas_regions/").concat(atlasRegion);
                        return {
                            nearestAppRegion: function () {
                                var nearestAppRegion = "".concat(atlasRegions, "/nearest_app_region");
                                return {
                                    get: function () { return privateApi._get(nearestAppRegion, Region_1.NearestAppRegion); },
                                };
                            },
                        };
                    },
                };
            },
        };
    };
    BaasAdminClient.prototype.apiMethods = function (apiType, apiVersion) {
        var _this = this;
        var doRequest = function (url, method, options) {
            return _this._do(url, method, __assign({ apiType: apiType, apiVersion: apiVersion }, options));
        };
        var doJSON = function (url, method, options) {
            return doRequest(url, method, options).then(function (response) {
                var contentHeader = response.headers.get('content-type') || '';
                if (contentHeader.split(',').indexOf('application/json') >= 0) {
                    return response.json();
                }
                return response;
            });
        };
        var doText = function (url, method, options) {
            return doRequest(url, method, options).then(function (response) { return response.text(); });
        };
        var doTyped = function (url, method, resultType, data, options) {
            if (data) {
                if (!options) {
                    options = {};
                }
                options.body = JSON.stringify(jsonConvert.serialize(data));
            }
            return doText(url, method, options).then(function (response) {
                return jsonConvert.deserializeObject(bson_1.EJSON.parse(response), resultType);
            });
        };
        var doTypedJSON = function (url, method, resultType, data, options) {
            if (data) {
                if (!options) {
                    options = {};
                }
                options.body = JSON.stringify(jsonConvert.serialize(data));
            }
            return doJSON(url, method, options).then(function (response) { return jsonConvert.deserializeObject(response, resultType); });
        };
        var doTypedNoContent = function (url, method, data, options) {
            if (data) {
                if (!options) {
                    options = {};
                }
                options.body = JSON.stringify(jsonConvert.serialize(data));
            }
            return doJSON(url, method, options);
        };
        var doTypedList = function (url, method, resultType, data, options) {
            if (data) {
                if (!options) {
                    options = {};
                }
                options.body = JSON.stringify(jsonConvert.serialize(data));
            }
            return doText(url, method, options).then(function (response) {
                return Object.values(bson_1.EJSON.parse(response)).map(function (val) {
                    var isPrimitive = val !== Object(val);
                    if (isPrimitive) {
                        return val;
                    }
                    return jsonConvert.deserializeObject(val, resultType);
                });
            });
        };
        return {
            _delete: function (url, queryParams) {
                return doJSON(url, 'DELETE', queryParams ? { queryParams: queryParams } : undefined);
            },
            _get: function (url, resultType, queryParams, headers, options) {
                return doTyped(url, 'GET', resultType, undefined, __assign({ headers: headers, queryParams: queryParams }, options));
            },
            _getConvert: function (converter, url, queryParams, headers, options) {
                return doText(url, 'GET', __assign({ headers: headers, queryParams: queryParams }, options)).then(function (response) { return converter(bson_1.EJSON.parse(response)); });
            },
            _getUntyped: function (url, queryParams, headers, options) { return doJSON(url, 'GET', __assign({ queryParams: queryParams, headers: headers }, options)); },
            _list: function (url, resultType, queryParams, headers, options) {
                return doTypedList(url, 'GET', resultType, undefined, __assign({ headers: headers, queryParams: queryParams }, options));
            },
            _listConvert: function (url, converter, queryParams, headers, options) {
                return doText(url, 'GET', __assign({ headers: headers, queryParams: queryParams }, options)).then(function (response) {
                    return Object.values(bson_1.EJSON.parse(response)).map(function (val) { return converter(val); });
                });
            },
            _patch: function (url, data) { return doTypedNoContent(url, 'PATCH', data); },
            _patchTyped: function (url, resultType, data) { return doTyped(url, 'PATCH', resultType, data); },
            _patchRaw: function (url, options) { return doJSON(url, 'PATCH', options); },
            _post: function (url, resultType, data, queryParams, options) { return doTyped(url, 'POST', resultType, data, __assign({ queryParams: queryParams }, options)); },
            _postTypedJSON: function (url, resultType, data, queryParams, options) { return doTypedJSON(url, 'POST', resultType, data, __assign({ queryParams: queryParams }, options)); },
            _postConvert: function (url, data, converter, queryParams) {
                return doText(url, 'POST', {
                    body: JSON.stringify(jsonConvert.serialize(data)),
                    queryParams: queryParams,
                }).then(function (response) { return converter(bson_1.EJSON.parse(response)); });
            },
            _postNoContent: function (url, data, queryParams) {
                return doTypedNoContent(url, 'POST', data, { queryParams: queryParams });
            },
            _postRaw: function (url, options) { return doJSON(url, 'POST', options); },
            _postUntyped: function (url, body, queryParams) {
                return doJSON(url, 'POST', {
                    body: body ? JSON.stringify(body) : undefined,
                    queryParams: queryParams,
                });
            },
            _put: function (url, data, queryParams, options) {
                return doTypedNoContent(url, 'PUT', data, __assign({ queryParams: queryParams }, options));
            },
            _putRaw: function (url, options) { return doJSON(url, 'PUT', options); },
        };
    };
    return BaasAdminClient;
}());
exports.default = BaasAdminClient;
//# sourceMappingURL=Client.js.map